import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ExpertProductApi from '../../../api/ExpertProductApi';
import UserApi from '../../../api/UserApi';
import ExpertProductList from "./ExpertProductList";
import ExpertConnectionPop from '../../popup/ExpertConnectionPop';
import { resolveProfileImg } from '../../../util/ProfileUtil';

const ExpertDetail = () => {
    const { expertProductOwnerId } = useParams();
    const [expert, setExpert] = useState({});
    const [expertConnectionPopOpen, setExpertConnectionPopOpen] = useState(false);

    const handleInquiryClick = () => {
        setExpertConnectionPopOpen(true);
    }

    useEffect(() => {
        // 전문가 정보 가져오기
        if (expertProductOwnerId) {
            UserApi.getExpertInfo(expertProductOwnerId).then(expertData => {
                setExpert(expertData);
            });
        }
    }, [expertProductOwnerId])
    
    return (
        <div className="vh-content">
            <ExpertProductList
                title="서비스"
                useSearch={false}
                useFilter={false}
                expert_product_owner_id={expertProductOwnerId}
                showAside={false}
            >
                <div class="section-header">
                    <h1 class="section-header-title">전문가 정보</h1>
                </div>  
                <div class="expert-info-area">
                    <div class="expert-profile">
                        <div class="expert-profile-thumb">
                            <img src={resolveProfileImg(expert.user_profile_img, expertProductOwnerId)} alt="전문가 프로필" />
                        </div>
                        <div class="expert-profile-text">
                            <p>{expert.user_nicknm}</p>
                            <span class="likeBtn"><i class="icon icon-heart-red"></i> {expert.user_expert_like_cnt}</span>
                        </div>
                    </div>
                    <button class="btn btn-primary" onClick={handleInquiryClick}>문의하기</button>
                </div>
                <div class="section-header">
                    <h1 class="section-header-title">전문가 소개</h1>
                </div>
                <div class="expert-comment">
                    <pre>								
                        {expert.expert_describe}
                    </pre>
                </div>
            </ExpertProductList>
            
            {expertConnectionPopOpen && (
                <ExpertConnectionPop 
                    ownerId={expertProductOwnerId}
                    onClose={() => setExpertConnectionPopOpen(false)}
                />
            )}
        </div>
        
    )
}

export default ExpertDetail;